import PropTypes from 'prop-types'

const loaderSelector = 'loader'
const spinnerSelector = 'fal fa-spinner-third fa-spin'
const spinnerElement = <i className={ spinnerSelector } />

/**
 * @deprecated Use Loader component instead.
 */
export function createLoader () {
  $('body').append('<div class="' + loaderSelector + '"><i class="' + spinnerSelector + '" /></div>')
}

/**
 * @deprecated Use Loader component instead.
 */
export function removeLoader () {
  $('.' + loaderSelector).remove()
}

/**
 * @deprecated Use Loader component instead.
 */
export const Loader = () => {
  return (
    <div className='loader'>{ spinnerElement }</div>
  )
}

export const defaultStyle = { margin: '1rem', fontSize: '36pt', textAlign: 'center' }

const fullOverlayStyle = {
  ...defaultStyle,
  margin: 0,
  fontSize: '60pt',
  color: '#fff',
  zIndex: 10,
  backgroundColor: 'rgba(0,0,0, 0.3)',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
}

const fullOverlayClasses = [
  'd-flex', 'justify-content-center', 'align-items-center', 'w-100', 'h-100', 'position-fixed', 'text-center'
].join(' ')

/**
 * @deprecated Use Loader component instead.
 */
export const CustomLoader = ({ className, style, isFullOverlay = false }) => {
  style = style || (isFullOverlay ? fullOverlayStyle : defaultStyle)
  className = className || (isFullOverlay ? fullOverlayClasses : undefined)

  return (
    <div className={ className } style={ style }>
      { spinnerElement }
    </div>
  )
}

CustomLoader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isFullOverlay: PropTypes.bool
}
